import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AttachmentsListComponent } from './attachments-list/attachments-list.component';
import { GenericAttachmentsListComponent } from './generic-attachments-list/generic-attachments-list.component';

const routes: Routes = [
  { path: "attachments", component: AttachmentsListComponent},
  { path: "genericAttachments", component: GenericAttachmentsListComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AttachmentsRoutingModule { }
